export default __webpack_public_path__ + "static/6-f418ce6a242d17a7aa382888568787af.jpg";